import _ from 'lodash';
import { useMemo } from 'react';
import { CreativeVideo } from '../../../../../types';
import { CreativeTemplatesEntities, Views } from '../../../../../constants';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';
import { CarouselCreative, CarouselSlide } from '../../../../../types/CarouselCreative.type';

export const useVideosGallery = () => {
  const store = useCreativeTemplatesBuilderStore();

  const isSelected = (video: CreativeVideo) => {
    switch (store.view) {
      case Views.ImageOrVideoCreativeTemplateEditor:
        const videos = store.imageOrVideoCreativeTemplateInputs[CreativeTemplatesEntities.VIDEOS];
        return _.some(videos, { id: video.id });
      case Views.CarouselCreativeTemplateEditor:
        const allVideos = _.reduce(store.carousels, carouselsReducer, [] as CreativeVideo[]);
        return _.some(_.uniqBy(allVideos, 'id'), { id: video.id });
      default:
        return false;
    }
  };

  const handleVideoSelect = (video: CreativeVideo, checked: boolean) => {
    if (store.view === Views.CarouselCreativeTemplateEditor) {
      const updatedCarousels = _.map(store.carousels, (carousel) => mapCarousels(carousel, video));
      store.setCarousels(updatedCarousels as CarouselCreative[]);
    }

    if (store.view === Views.ImageOrVideoCreativeTemplateEditor) {
      store.selectVideo(video, checked);
    }
  };

  const mapCarousels = (carousel: CarouselCreative, video: CreativeVideo) => {
    const updatedSlides = _.map(carousel.carouselAssetSpecs, (slide) => mapSlides(slide, video));
    return { ...carousel, carouselAssetSpecs: updatedSlides };
  };

  const mapSlides = (slide: CarouselSlide, video: CreativeVideo) => {
    return slide.id === store.activeSlideId ? { ...slide, image: null, video } : slide;
  };

  const carouselsReducer = (acc: CreativeVideo[], currentValue: CarouselCreative) => {
    const carouselVideos = _.compact(_.map(currentValue.carouselAssetSpecs, 'video'));
    return [...acc, ...carouselVideos];
  };

  const videos = useMemo(() => store.videos, [store.videos]);

  return { videos, isSelected, handleVideoSelect };
};
